export default "__VITE_ASSET__C6mGg$ZI__"